import React, { Component } from 'react';
import { Row, Col, } from 'reactstrap';
import { NUMERIC } from '../../constants'
class VariablePredefined extends Component {
    render() {
        return (
            <Col xs="24">
                <Row className="header-blue">
                    <Col xs="12">Field Name</Col>
                    <Col xs="6">Field Type</Col>
                    <Col xs="4">Value/Interpolated</Col>
                </Row>
                {
                    this.props.predefinedData.map(p => {
                        return (
                            <Row key={p.id} className="modal-report-type-item ">
                                <Col xs="12">{p.fieldName}</Col>
                                <Col xs="6">{p.fieldType}</Col>
                                <Col xs="4">{(p.fieldType === NUMERIC) ? (p.interpolated).toString() : p.fieldValue}</Col>
                            </Row>
                        )
                    })
                }
            </Col>
        )
    }
}

export default VariablePredefined